export const ctaContent = {
  title: "Ready to unlock your data's potential?",
  actionLabel: "Let's talk",
};
